// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"styles_layoutWrapperMain__3vwWl","root":"styles_root__1tBRb","container":"styles_container__Nkk4L"};